<template>
  <div class="avatar-head-menu">
    <v-avatar
      color="secondary"
      v-if="user !== null"
    >
      <img
        v-if="user.photoURL"
        :src="user.photoURL"
        :alt="user.displayName || user.email"
      >
      <span v-if="!user.photoURL" class="white--text">
        {{ user.displayName ? user.displayName[0] : user.email[0] }}
      </span>
    </v-avatar>
    <v-avatar
      color="secondary"
      v-else
    >
      <v-icon dark>mdi-account-circle</v-icon>
    </v-avatar>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      required: true,
      default: null
    }
  }
}
</script>
